import { render } from "./CmpCobroPendiente.vue?vue&type=template&id=948c0df2&scoped=true"
import script from "./CmpCobroPendiente.vue?vue&type=script&lang=js"
export * from "./CmpCobroPendiente.vue?vue&type=script&lang=js"

import "./CmpCobroPendiente.vue?vue&type=style&index=0&id=948c0df2&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948c0df2"]])

export default __exports__